import * as React from "react";
/** Components */
import Copy from "../Copy";
import ProgressBar from "../ProgressBar/ProgressBar";
import { colorBrandRhumbixBlack } from "@rhumbix/rmbx_design_system_design_tokens";
/** Styles */
import styled from "styled-components";
const ProgressBarContainer = styled.div `
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 130px;
`;
const LabeledProgressBar = ({ boldLabel = false, percentComplete = 0 }) => {
    return (React.createElement(ProgressBarContainer, null,
        React.createElement(ProgressBar, { percentComplete: percentComplete }),
        React.createElement(Copy, { bold: boldLabel, color: colorBrandRhumbixBlack }, percentComplete + "%")));
};
export default LabeledProgressBar;
